module.exports = __webpack_public_path__ + "media/country_flags/bs-61f95067.png";